import React from 'react';

/** Recognizable Instagram glyph (rounded square + lens + flash dot). */
export function InstagramIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z" />
      <path d="M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
    </svg>
  );
}

export function FacebookIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.469-4.122 4.275v2.78H7.332v3.209h2.747v8.202h3.318z" />
    </svg>
  );
}

export function LinkedInIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

/** Official-style TikTok note glyph. */
export function TikTokIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M19.321 5.562a5.122 5.122 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.849-1.295-1.92-1.437-2.838h-.01V2h-3.677v13.19a3.108 3.108 0 0 1-2.928 3.045 3.04 3.04 0 0 1-3.096-2.987 3.077 3.077 0 0 1 3.072-3.088c.318 0 .623.05.91.142V9.398a6.763 6.763 0 0 0-1.035-.079 6.28 6.28 0 0 0-6.279 6.28 6.28 6.28 0 0 0 6.28 6.279 6.273 6.273 0 0 0 6.266-6.287V8.406a8.328 8.328 0 0 0 4.77 1.483v-3.6a5.328 5.328 0 0 1-1.096-.127z" />
    </svg>
  );
}

/** Official TikTok wordmark image for the social follow badge (light-bordered pill). */
export function TikTokBadgeLogo({ height = 18, className = '' }) {
  return (
    <img
      src="/images/tiktok-logo.png"
      alt=""
      height={height}
      className={`social-tiktok-logo-img ${className}`.trim()}
      loading="lazy"
      decoding="async"
      aria-hidden
    />
  );
}

/** X (formerly Twitter) brand mark — single-path logo. */
export function XIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231z" />
    </svg>
  );
}

export function SocialPlatformIcon({ platform, size = 22, className = '' }) {
  const wrapClass = `social-story-ring-platform-icon ${className}`.trim();
  if (platform === 'instagram') {
    return (
      <span className={wrapClass}>
        <InstagramIcon size={size} />
      </span>
    );
  }
  if (platform === 'facebook') {
    return (
      <span className={wrapClass}>
        <FacebookIcon size={size} />
      </span>
    );
  }
  if (platform === 'linkedin') {
    return (
      <span className={wrapClass}>
        <LinkedInIcon size={size} />
      </span>
    );
  }
  return null;
}
